// extracted by css-extract-rspack-plugin
var _1 = "gJjU9w2KNeMRJbat";
var _2 = "cY56UTU9dQxGcc1F";
var _3 = "k0QoN2PaJiYNm05k";
var _4 = "VXBavvnadccriXoL";
var _5 = "UDM34_PgYdcU1Ijl";
var _6 = "cY56UTU9dQxGcc1F";
var _7 = "k0QoN2PaJiYNm05k";
var _8 = "VXBavvnadccriXoL";
var _9 = "UDM34_PgYdcU1Ijl";
var _a = "N3YJrXlOHOEzNc3H";
var _b = "rNjZrlvwqhAB5Udn";
var _c = "efbusPSo98s11I1k";
var _d = "vFq5jTqwVTNI02By";
var _e = "EJcL9Bty3pQ1w1AR";
var _f = "TPKOFpx5m7sJzKou";
var _10 = "rNjZrlvwqhAB5Udn";
var _11 = "Yzw3qq_mlf0RFIua";
var _12 = "efbusPSo98s11I1k";
var _13 = "vFq5jTqwVTNI02By";
var _14 = "EJcL9Bty3pQ1w1AR";
var _15 = "TPKOFpx5m7sJzKou";
var _16 = "Yzw3qq_mlf0RFIua";
var _17 = "SVja0MjX1dgkTfnJ";
var _18 = "C4e973quMHktntj4";
var _19 = "SF7jZSlbJ3ofmYeN";
var _1a = "C4e973quMHktntj4";
var _1b = "SF7jZSlbJ3ofmYeN";
export { _1 as "caption", _2 as "caption--l", _3 as "caption--m", _4 as "caption--s", _5 as "caption--xl", _6 as "captionL", _7 as "captionM", _8 as "captionS", _9 as "captionXl", _a as "footer", _b as "footer--copyright", _c as "footer--links", _d as "footer--logo", _e as "footer--privacy", _f as "footer--sep", _10 as "footerCopyright", _11 as "footerLang", _12 as "footerLinks", _13 as "footerLogo", _14 as "footerPrivacy", _15 as "footerSep", _16 as "footer__lang", _17 as "section", _18 as "section-title", _19 as "sectionContent", _1a as "sectionTitle", _1b as "section__content" }
